import React from 'react';
import { LocaleRouter } from '@binaa-almajal/ui-kit/providers/LocaleRouter';
import AppRoutes from './AppRoutes';
import { AppProviders } from './providers/AppProviders';
import { ErrorBoundary } from '@binaa-almajal/ui-kit/providers/ErrorBoundary';

// The boundary wraps the providers, not the other way round: a provider that
// throws during render must land somewhere, and the boundary's fallback
// deliberately depends on nothing below it. Provider order and its
// constraints live in AppProviders.
function App() {
    return (
        <ErrorBoundary>
            <AppProviders>
                <LocaleRouter>
                    <AppRoutes />
                </LocaleRouter>
            </AppProviders>
        </ErrorBoundary>
    );
}

export default App;
